import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_partner_login_form = _resolveComponent("partner-login-form")!
  const _component_login_content = _resolveComponent("login-content")!

  return (_openBlock(), _createBlock(_component_login_content, { title: _ctx.title }, {
    default: _withCtx(() => [
      _createVNode(_component_partner_login_form)
    ]),
    _: 1
  }, 8, ["title"]))
}